import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { ENGLISH, GERMAN } from "./localeResources";

export const SUPPORTED_LANGUAGES = ["en", "de"] as const;

/** Where the chosen language is kept in the browser. */
export const LANGUAGE_STORAGE_KEY = "i18nextLng";

// English is the fallback: a key missing in German then shows English text, never the raw
// key (UX-23). Both locales hold the same keys; `locales.test.ts` checks that.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { common: GERMAN },
      en: { common: ENGLISH },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false },
    // Views re-render when the ontology's words for its terms arrive (`processTermWords.ts`).
    react: { bindI18nStore: "added" },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
  });

if (typeof window !== "undefined") {
  // The page says its language, so screen readers and hyphenation follow it.
  const sayLanguage = () => { document.documentElement.lang = i18n.resolvedLanguage ?? "en"; };
  sayLanguage();
  i18n.on("languageChanged", sayLanguage);

  // A language chosen in another tab of the app, such as the help beside it, shows here too (WA-6).
  window.addEventListener("storage", (event) => {
    if (event.key === LANGUAGE_STORAGE_KEY && event.newValue !== null && event.newValue !== i18n.resolvedLanguage) {
      void i18n.changeLanguage(event.newValue);
    }
  });
}

export default i18n;
